import { FormNodeBase } from '../kiosk';
import { SettingTermKeys } from '../settings';

export type DealerPIIType =
  | 'addressCity'
  | 'addressCountry'
  | 'addressLine1'
  | 'addressLine2'
  | 'addressState'
  | 'addressZipcode'
  | 'email'
  | 'name';

export const DealerPIITypes: DealerPIIType[] = [
  'addressCity',
  'addressCountry',
  'addressLine1',
  'addressLine2',
  'addressState',
  'addressZipcode',
  'email',
  'name',
];

export interface FormNodeDealerPIIModel extends FormNodeBase {
  type: 'dealerPii';
  width?: 'full' | 'half';
  subType: DealerPIIType;
  markdown?: string;
  infoText?: string;
}

export interface FormNodeDealerOptionModel extends FormNodeBase {
  type: 'dealerOption';
  optionId: number;
  applicationOnly?: boolean;
  hidden?: boolean;
  required?: boolean;
}

export interface FormNodeSimpleLinkedTermsModel extends FormNodeBase {
  type: 'simpleLinkedTerms';
  displayName: string;
  termsKey: SettingTermKeys | 'none';
  agreementType: 'checkbox' | 'name';
  requireChecked: boolean;
  showPreview: boolean;
}
